import { render } from "./AddOrderProducts.vue?vue&type=template&id=28fd14bc&scoped=true&ts=true"
import script from "./AddOrderProducts.vue?vue&type=script&lang=ts"
export * from "./AddOrderProducts.vue?vue&type=script&lang=ts"

import "./AddOrderProducts.vue?vue&type=style&index=0&id=28fd14bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fd14bc"]])

export default __exports__